import type { Card } from '@durakapp/engine';
import { CardBack, CardFace } from './Card.js';

interface Props {
  count: number;
  trump: Card;
}

export function Deck({ count, trump }: Props) {
  if (count === 0) {
    return (
      <div className="flex flex-col items-center gap-1">
        <span className="text-xs text-ivory/60">Колода пуста</span>
      </div>
    );
  }
  return (
    <div className="relative flex flex-col items-center" style={{ width: 86 }}>
      <div className="relative h-[88px]">
        <div className="absolute -left-3 top-3 -rotate-90 origin-center">
          <CardFace card={trump} size="sm" />
        </div>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="absolute"
            style={{ transform: `translate(${i * 1.5}px, ${i * -1.5}px)`, zIndex: i }}
          >
            <CardBack size="sm" />
          </div>
        ))}
      </div>
      <span className="mt-2 text-xs text-gold">{count}</span>
    </div>
  );
}
